import { List } from 'immutable';
import { Table, SortTH } from 'foundations-components/transitional/components/Table';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import SimpleHubPickerRow from './SimpleHubPickerRow';
import I18n from 'I18n';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import RequestStatusTypes from 'hub-pickers-lib/constants/RequestStatusTypes';
import links from '../utils/links';
import { getAccountsCrossHublet } from '../Accounts/AccountFetcher';
import { sortByField } from '../utils/sorts';
import { EmptyTableRow, EmptyTableCell } from './HubPicker';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SimpleHubPicker = ({
  redirectTo = links.homeService,
  query = {},
  filter = ''
}) => {
  const [accounts, setAccounts] = useState(List());
  const [accountsRequestStatus, setAccountsRequestStatus] = useState(RequestStatusTypes.UNINITIALIZED);
  const [sortField, setSortField] = useState(null);
  const [sortDir, setSortDir] = useState(null);
  useEffect(() => {
    void getAccountsCrossHublet(true, false).then(value => {
      setAccounts(value.accounts);
      setAccountsRequestStatus(value.accountsRequestStatus);
    });
  }, []);
  const getFilteredAccounts = () => {
    if (!filter) {
      return accounts;
    }
    const filterText = filter.toLowerCase();
    return accounts.filter(account => account.accountName.toLowerCase().includes(filterText) || account.domain.toLowerCase().includes(filterText) || account.id.toString().includes(filterText));
  };
  const onSortChange = field => {
    return event => {
      const value = event.target.value;
      const sortedAccounts = accounts.sort(sortByField(field, value));
      setSortDir(value);
      setSortField(field);
      setAccounts(sortedAccounts);
    };
  };
  const renderLoader = () => {
    return /*#__PURE__*/_jsx("tr", {
      children: /*#__PURE__*/_jsx("td", {
        colSpan: 3,
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          minHeight: 50
        })
      })
    });
  };
  const renderTableContents = () => {
    const filteredAccounts = getFilteredAccounts();
    if (filteredAccounts.size === 0) {
      return /*#__PURE__*/_jsx(EmptyTableRow, {
        children: /*#__PURE__*/_jsx(EmptyTableCell, {
          colSpan: 3,
          children: I18n.text('hubPicker.noFilteredResults')
        })
      });
    }
    return filteredAccounts.map((account, key) => {
      return /*#__PURE__*/_jsx(SimpleHubPickerRow, {
        account: account,
        query: query,
        redirectTo: redirectTo
      }, key);
    });
  };
  const loading = accountsRequestStatus === RequestStatusTypes.PENDING || accountsRequestStatus === RequestStatusTypes.UNINITIALIZED;
  if (accountsRequestStatus === RequestStatusTypes.FAILED) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest",
      children: /*#__PURE__*/_jsx("p", {
        children: I18n.text('error.requestFailed.description')
      })
    });
  } else if (!loading && accounts.size === 0) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: "cone",
      type: "expired",
      children: /*#__PURE__*/_jsx("p", {
        children: I18n.text('error.noAccounts.description')
      })
    });
  }
  return /*#__PURE__*/_jsxs(Table, {
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx("col", {
        style: {
          width: '300px'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '200px'
        }
      })]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx(SortTH, {
          sort: sortField === 'accountName' && sortDir ? sortDir : 'none',
          onSortChange: onSortChange('accountName'),
          children: I18n.text('hubPicker.name')
        }), /*#__PURE__*/_jsx(SortTH, {
          sort: sortField === 'domain' && sortDir ? sortDir : 'none',
          onSortChange: onSortChange('domain'),
          children: I18n.text('hubPicker.domain')
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: loading ? renderLoader() : renderTableContents()
    })]
  });
};
export default SimpleHubPicker;